import { gql } from 'graphql-request';

export const ALERT_FRAGMENT = gql`
    fragment AlertFields on Alert {
        id
        companyHotelId
        creationDate
        name
        state
        type
        filter {
            refunding
            roomTypes
            lengthOfStay
            meal
        }
        schedule {
            type
            weekdays
            time
        }
        timeframe {
            days
        }
        extraEmails
        recipientsType
        recipientProfileIds
    }
`

export const PRICE_COMPARISON_ALERT_RULE_FRAGMENT = gql`
    fragment PriceComparisonAlertRuleFields on PriceComparisonAlertRule {
        competitorIds
        pricePoint
        priceRange {
            from
            to
        }
        trigger
    }
`

export const PARITY_PRICE_COMPARISON_ALERT_RULE_FRAGMENT = gql`
    fragment ParityPriceComparisonAlertRuleFields on ParityPriceComparisonAlertRule {
        providers
        triggerDifference
        differenceType
        ignorePartnerOffers
        includeGoogleMetasearch
    }
`

export const COMPETITORS_SOLD_OUT_ALERT_RULE_FRAGMENT = gql`
    fragment CompetitorsSoldOutAlertRuleFields on CompetitorsSoldOutAlertRule {
        competitorIds
        competitorsInclusion
        inclusionPercentage
    }
`

export const COMPETITORS_PRICE_RATE_ALERT_RULE_FRAGMENT= gql`
    fragment CompetitorsPriceRateAlertRuleFields on CompetitorsPriceRateAlertRule {
        competitorIds
        priceRatePercentage
        calculation
        competitorsInclusion
        pastPeriodInDays
        roomComparison
        inclusionPercentage
    }
`

export const ALERT_OUTPUT_FRAGMENT = gql`
    ${ALERT_FRAGMENT}
    ${COMPETITORS_PRICE_RATE_ALERT_RULE_FRAGMENT}
    ${PRICE_COMPARISON_ALERT_RULE_FRAGMENT}
    ${PARITY_PRICE_COMPARISON_ALERT_RULE_FRAGMENT}
    ${COMPETITORS_SOLD_OUT_ALERT_RULE_FRAGMENT}
    fragment AlertOutputFields on AlertOutput {
        alert {
            ...AlertFields
        }
        competitors {
            id
            name
        }
        competitorsPriceRateAlertRule {
            ...CompetitorsPriceRateAlertRuleFields
        }
        priceComparisonAlertRule {
            ...PriceComparisonAlertRuleFields
        }
        parityPriceComparisonAlertRule {
            ...ParityPriceComparisonAlertRuleFields
        }
        competitorsSoldOutAlertRule {
            ...CompetitorsSoldOutAlertRuleFields
        }
    }
`

export const PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATION = gql`
    fragment PriceComparisonAlertExecutionNotificationFields on PriceComparisonAlertExecutionNotification {
        id
        creationDate
        state
        companyHotelId
        alertId
        alertExecutionId
        marketStateId
        statDate
        price {
            amount
            currency
        }
        competitorsPrice {
            amount
            currency
        }
        competitorId
    }   
`

export const PARITY_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATION = gql`
    fragment ParityPriceComparisonAlertExecutionNotificationFields on ParityPriceComparisonAlertExecutionNotification {
        id
        creationDate
        state
        companyHotelId
        alertId
        alertExecutionId
        statDate
        brandPrice {
            amount
            currency
        }
        providerStats {
            provider
            price {
                amount
                currency
            }
            difference
            percentage
            isOta
            iconUrl
        }
    }
`

export const COMPETITORS_SOLD_OUT_ALERT_EXECUTION_NOTIFICATION = gql`
    fragment CompetitorsSoldOutAlertExecutionNotificationFields on CompetitorsSoldOutAlertExecutionNotification {
        id
        creationDate
        state
        companyHotelId
        alertId
        alertExecutionId
        statDate
        soldOutHotelIds
        newSoldOutHotelIds
    }
`

export const COMPETITORS_PRICE_RATE_ALERT_EXECUTION_NOTIFICATION = gql`
    fragment CompetitorsPriceRateAlertExecutionNotificationFields on CompetitorsPriceRateAlertExecutionNotification {
        id
        creationDate
        state
        companyHotelId
        alertId
        alertExecutionId
        statDate
        average
        competitorStats {
            competitorId
            fromRoomName
            fromRoomType
            toRoomName
            toRoomType
            rate
            from
            to
        }
    }
`

export const ALERT_EXECUTION_FRAGMENT = gql`
    ${ALERT_OUTPUT_FRAGMENT}
    fragment AlertExecutionFields on AlertExecution {
        id
        alertId
        state
        creationDate
        executionDate
        numberOfNotifications
        alertOutput {
            ...AlertOutputFields
        }
    }
`